// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3avyk","right":"styles_right__Pp4V5"};